import { stringify } from '../libs/queryString';

export function getEditorLink({
  metaSiteId,
  cmsTemplateId,
  templateName,
  editorSessionId,
  petri_ovr,
  dashboardFirstMetaSiteId,
  siteCreationFolderId,
  dashboardFirst,
  autoDetectCategory,
  fromOrigin,
}: {
  metaSiteId: string;
  cmsTemplateId?: string;
  templateName?: string;
  editorSessionId: string;
  petri_ovr?: string;
  dashboardFirstMetaSiteId?: string;
  siteCreationFolderId?: string;
  dashboardFirst?: string;
  autoDetectCategory?: boolean;
  fromOrigin?: string; // requested by Editor team
}) {
  const isAutoDetectCategoryConducted = autoDetectCategory !== undefined;

  return `https://manage.wix.com/edit-template/from${dashboardFirstMetaSiteId ? '-intro-siteless' : ''}?${stringify({
    originTemplateId: metaSiteId,
    editorSessionId,
    petri_ovr,
    siteCreationFolderId,
    metaSiteId: dashboardFirstMetaSiteId,
    dashboardFirst,
    autoDetectCategory: isAutoDetectCategoryConducted ? String(autoDetectCategory) : undefined,
    cmsTemplateId: isAutoDetectCategoryConducted ? cmsTemplateId : undefined,
    templateName: isAutoDetectCategoryConducted ? templateName : undefined,
    fromOrigin,
  })}`;
}

export function getViewerLink({
  templateSlug,
  language,
  originUrl,
  editorSessionId,
  dashboardFirstMetaSiteId,
  dashboardFirst,
  fromOrigin,
}: {
  templateSlug: string;
  language: string;
  originUrl: string;
  editorSessionId: string;
  dashboardFirstMetaSiteId?: string;
  dashboardFirst?: string;
  fromOrigin?: string; // hehehe
}) {
  return `https://${
    language === 'en' ? 'www' : language
  }.wix.com/website-template/view/html/${templateSlug}?${stringify({
    originUrl,
    esi: editorSessionId,
    dashboardFirstMetaSiteId,
    dashboardFirst,
    fromOrigin,
  })}`;
}
